import PageScrollProgressBar from "./PageScrollProgressBar/PageScrollProgressBar";
export default PageScrollProgressBar;
